'use client';

import { useEffect, useState, useTransition } from 'react';
import { EnvelopeIcon } from '@phosphor-icons/react/ssr';
import { resendVerification } from '@/shared/api/auth/resend-verification';
import { Button } from '@/shared/ui/core';
import styles from './resend-verification.module.scss';


const RESEND_COOLDOWN_SECONDS = 60;


type Props = {
    email: string;
};


export const ResendVerification = ({ email }: Props) => {
    const [ secondsLeft, setSecondsLeft ] = useState(RESEND_COOLDOWN_SECONDS);
    const [ isPending, startTransition ]  = useTransition();

    useEffect(() => {
        if (secondsLeft <= 0) return;

        const intervalId = setInterval(() => {
            setSecondsLeft((prev) => Math.max(0, prev - 1));
        }, 1000);

        return () => clearInterval(intervalId);
    }, [ secondsLeft ]);

    const handleResend = () => {
        if (!email) return;

        startTransition(async () => {
            const result = await resendVerification({ email });

            if (result.success) {
                setSecondsLeft(RESEND_COOLDOWN_SECONDS);
            }
        });
    };

    const isDisabled = secondsLeft > 0 || isPending || !email;

    return (
        <Button
            leftIcon={ <EnvelopeIcon size={ 16 }/> }
            disabled={ isDisabled }
            onClick={ handleResend }
        >
            Resend verification email
            {
                !!secondsLeft &&
                <span className={ styles.time }>
                    &nbsp;({ secondsLeft.toString().padStart(2, '0') })
                </span>
            }
        </Button>
    );
};
